export function stripHttpProtocol(value) {
  return value.replace(/^https?:\/\//i, '');
}

export function normalizeOnboardingSiteUrl(value) {
  const strippedValue = stripHttpProtocol((value ?? '').trim());

  if (!strippedValue) {
    return '';
  }

  const emailMatch = strippedValue.match(/^[^@\s]+@([^@\s]+\.[^@\s]+)$/);

  if (emailMatch) {
    return emailMatch[1].toLowerCase();
  }

  return strippedValue;
}

export function normalizeUrlWithHttps(value) {
  const valueWithoutProtocol = normalizeOnboardingSiteUrl(value);

  if (!valueWithoutProtocol) {
    return '';
  }

  return `https://${valueWithoutProtocol}`;
}

export const withQueryParams = (path, queryString = '', upserts = {}) => {
  const params = new URLSearchParams(queryString);

  Object.entries(upserts).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') {
      params.delete(key);
      return;
    }

    params.set(key, String(value));
  });

  const nextQueryString = params.toString();

  return nextQueryString ? `${path}?${nextQueryString}` : path;
};

export function getFlowDestination(flow) {
  switch (flow) {
    case 'conversions':
      return '/goals';
    case 'heatmaps':
      return '/snapshots';
    case 'surveys':
      return '/addons?type=SURVEYS';
    case 'ctas':
      return '/addons?type=CTAS';
    case 'ab_testing':
      return '/ab-tests';
    case 'traffic_analysis':
      return '/traffic';
    case 'free':
    case 'web_analytics':
      return '/web-analytics';
    default:
      return `/${flow}`;
  }
}
